import { render, staticRenderFns } from "./InputBirthdayPicker.vue?vue&type=template&id=f98bd104&"
import script from "./InputBirthdayPicker.vue?vue&type=script&lang=js&"
export * from "./InputBirthdayPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports